import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface IreV2AreaObject {
  id: number;
  areaId: number;
  isActive: boolean;
  sort: number;
  areaName: string;
  customUpdatedAt: string;
}

export interface IreV2AreaAllListObject {
  id: number;
  titleEn: string;
  areas: any;
  areaName: string;
}
export interface AreaObject {
  id: number;
  title: string;
}

export interface IreV2AreasListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  errors: unknown;
}

@Module
export default class IreV2AreasModule
  extends VuexModule
  implements IreV2AreasListInfo
{
  ireV2Areas = [] as Array<IreV2AreaObject>;
  ireV2AllAreas = [] as Array<IreV2AreaAllListObject>;
  areasFilter = {} as IreV2AreaObject;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get ireV2Areas list
   * @returns Array<IreV2AreasObject>
   */
  get ireV2AreasList(): Array<IreV2AreaObject> {
    if (this.ireV2Areas.length > 0)
      this.ireV2Areas[0]['page'] = this.currentPage;
    return this.ireV2Areas;
  }

  /**
   * Get all ive areas list
   * @returns Array<AreaObject>
   */
  get ireV2AreaFilter(): IreV2AreaObject {
    return this.areasFilter;
  }

  /**
   * Get groups list
   * @returns Array<GroupObject>
   */
  get ireV2AreasAllList(): Array<IreV2AreaAllListObject> {
    return this.ireV2AllAreas;
  }

  /**
   * Get total items
   * @returns number
   */
  get ireV2AreasListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_IRE_V2_AREAS](data) {
    this.ireV2Areas = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_ALL_IRE_V2_AREAS](data) {
    this.ireV2AllAreas = data.data;
  }

  @Mutation
  [Mutations.SET_IRE_V2_AREA_FILTER](obj) {
    this.areasFilter.areaId = obj.areaId;
  }

  @Action
  [Actions.UPDATE_IRE_V2_AREA_FILTER](val) {
    this.context.commit(Mutations.SET_IRE_V2_AREA_FILTER, val);
  }

  @Mutation
  [Mutations.SET_IRE_V2_AREA_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_IRE_V2_AREAS_LIST]() {
    this.ireV2Areas = [] as Array<IreV2AreaObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.CREATE_IRE_V2_AREA](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/ive-v2-factors/areas', data)
      .then(({ data }) => {
        this.context.commit(Mutations.RESET_IRE_V2_AREAS_LIST);
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_IRE_V2_AREA](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/ive-v2-factors/areas', id)
      .then(() => {
        this.context.commit(Mutations.RESET_IRE_V2_AREAS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }
  @Action
  [Actions.DELETE_IRE_V2_SIZE_CONFIG](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/ive-v2-factors/ire-size-v2-config', id)
      .then(() => {
        return true;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_IRE_V2_AREA]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/ive-v2-factors/areas', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_IRE_V2_AREAS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_IRE_V2_AREA_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_IRE_V2_AREA_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_IRE_V2_AREA](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/ive-v2-factors/areas', id);
  }

  @Action
  [Actions.GET_IRE_V2_AREAS](options: { limit?: number } = { limit: 10 }) {
    ApiService.setAuthorizationHeader();
    const params = {
      page: this.currentPage,
      limit: options.limit,
      areaId: this.areasFilter.areaId ? this.areasFilter.areaId : '',
    };
    return ApiService.query('/ive-v2-factors/areas', { params })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_IRE_V2_AREAS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.GET_ALL_IRE_V2_AREAS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/ive-v2-factors/areas/all')
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ALL_IRE_V2_AREAS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
  @Action
  [Actions.UPDATE_IRE_SIZE_CONFIG_OPTIONS_V2](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/ive-v2-factors/ire-size-v2-config', data)
      .then(({ data }) => {
        // this.context.commit(Mutations.RESET__LIST);
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_IRE_PROPERTY_AGE_CONFIG_OPTIONS](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/ive-v2-factors/ire-property-v2-age-config', data)
      .then(({ data }) => {
        // this.context.commit(Mutations.RESET__LIST);
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }
}
